// extracted by mini-css-extract-plugin
export default {"navbar":"navBar_navbar__AfzIw","navbar__logo":"navBar_navbar__logo__BNqlO","navbar__sidebuttons":"navBar_navbar__sidebuttons__50PX9"};